var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.cameraType && _vm.iconData[_vm.cameraType])?_c('div',{staticClass:"camera-type",class:_vm.iconData[_vm.cameraType].class,attrs:{"title":_vm.iconData[_vm.cameraType].title}},[_c('icon',{attrs:{"name":_vm.iconData[_vm.cameraType].icon}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }